import styled from "styled-components";
import { CodeBlock as CommonCodeBlock, FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
import { HXCheckbox, HXTextField } from "./base.styles";
import InputAdornment from "@mui/material/InputAdornment";
import * as React from "react";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { fontWeights } from "healthex-common/weights";
import { HXButton } from "./HXButton";
import { AdminFormSection } from "./AdminFormShared.styles";
import { HXMenuButton } from "./HXMenuButton";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { fontSizes } from "healthex-common/sizes";
export const Parent = styled(FlexColumnDiv) `
    padding: 24px 0;
    align-items: flex-start;
    gap: 40px;
    flex: 1 0 0;
    align-self: stretch;
`;
export const CopyableInfoContainer = styled(HXTextField).attrs({
    disabled: true,
    InputProps: {
        startAdornment: React.createElement(InputAdornment, { position: "start" }, React.createElement(ContentCopy)),
    },
}) `
    & * {
        cursor: pointer;
    }
    background-color: transparent;
    & input.Mui-disabled {
        color: ${colors.black_main};
        -webkit-text-fill-color: ${colors.black_main};
        opacity: 1;
    }
`;
export const AgentStatus = styled(FlexColumnDiv) `
    margin-top: 16px;
    gap: 8px;
`;
export const AgentStatusRow = styled(FlexColumnDiv) `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_light};
    gap: 8px;
`;
export const AgentUpgradeRowWrap = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    display: flex;
    align-items: last baseline;
    gap: 20px;
`;
export const AgentUpgradeLeftCol = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    justify-content: center;
    float: left;
    width: 250px;
`;
export const AgentUpgradeRightCol = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    flex-grow: 1;
    float: none;
    margin: auto;
`;
export const ValidatedFauxButton = styled(HXButton).attrs({
    color: "success",
}) `
    pointer-events: none; // faux button = no hover state
`;
export const AgentErrorStatusTable = styled(FlexColumnDiv) `
    border: 1px solid ${colors.black_12};
`;
export const AgentOverallErrorStatusPositive = styled(FlexRowDiv) `
    padding: 8px 16px;
    background: ${colors.forest_50};
    color: ${colors.white_main};
    align-items: center;
    justify-content: space-between;
`;
export const AgentOverallErrorStatusMixed = styled(FlexRowDiv) `
    padding: 8px 16px;
    background: ${colors.sunset_50};
    color: ${colors.black_main};
    align-items: center;
    justify-content: space-between;
`;
export const AgentOverallErrorStatusNegative = styled(FlexRowDiv) `
    padding: 8px 16px;
    background: ${colors.tulip_50};
    color: ${colors.white_main};
    align-items: center;
    justify-content: space-between;
`;
export const AgentErrorStatus = styled(FlexColumnDiv) `
    padding: 16px;
    gap: 4px;
`;
export const AgentErrorStatusType = styled(FlexRowDiv) `
    gap: 4px;
    align-items: center;
`;
export const AgentErrorStatusValuePositive = styled.div `
    color: ${colors.forest_main};
    font-weight: normal;
`;
export const AgentErrorStatusValueNegative = styled.div `
    color: ${colors.tulip_main};
    font-weight: normal;
`;
export const AgentStatusHavingTrouble = styled.div `
    color: ${colors.black_lighter};
    font-weight: normal;
`;
export const AgentUpgradeMessage = styled.div `
    color: ${colors.black_lighter};
    font-weight: normal;
`;
export const AgentForceUpgradeMessage = styled.div `
    color: ${colors.tulip_50};
    font-weight: normal;
`;
export const DataAccessChoiceDetails = styled.div `
    margin: 0 42px;
`;
export const DataAccessChoice = styled(FlexColumnDiv) `
    max-width: 700px;
`;
export const CheckboxBold = styled(HXCheckbox) `
    .MuiFormControlLabel-label {
        font-weight: ${fontWeights.BOLD};
    }
`;
export const CheckboxNormal = styled(HXCheckbox) `
    .MuiFormControlLabel-label {
        font-weight: ${fontWeights.NORMAL};
    }
`;
export const DataConnectionChoice = styled(FlexColumnDiv) `
    max-width: 700px;
`;
export const AgentReceiveLoggingMessage = styled.div `
    color: ${colors.black_lighter};
    font-weight: normal;
    margin: 0 42px;
`;
export const AgentWhenLoggingDisabledMessage = styled.div `
    color: ${colors.black_lighter};
    font-weight: normal;
    margin: 16px 0px;
`;
export const AgentLogUploadContainer = styled(FlexRowDiv) `
    padding: 0px;
    gap: 16px;
`;
export const AgentLogUploadMessage = styled.div `
    color: ${(props) => (props.isEnabled ? colors.black_main : colors.black_30)};
    font-weight: normal;
    margin: 16px 0px;
`;
export const SendLogsButton = styled(HXButton) `
    margin: 0 16px;
`;
export const AdminDataSourceForm = styled(AdminFormSection) `
    margin-top: 16px;
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const EditIcon = styled(Edit) `
    &&& {
        color: ${colors.black_lighter};
    }
`;
export const RemoveIcon = styled(Delete) `
    li:not(.Mui-disabled) && {
        color: ${colors.tulip_main};
    }
`;
export const DestructiveText = styled.div `
    li:not(.Mui-disabled) & {
        color: ${colors.tulip_main};
    }
`;
export const CodeText = styled.span `
    font-family: monospace;
    color: ${colors.chips_redwood};
    font-size: ${fontSizes.SMALL};
`;
export const CodeBlock = styled(CommonCodeBlock) `
    align-self: unset;
`;
